import { useState } from "react"

import { Col, Modal, ModalBody, ModalTitle, Row } from "react-bootstrap"
import ModalHeader from "react-bootstrap/esm/ModalHeader"
import { toast } from "react-toastify"
import { finalize } from "rxjs/operators"

import DonorGrid from "./DonorGrid"
import OrphanedRow from "../../../api/OrphanedResults/Models/OrphanedRow"
import PendingDrugTest from "../../../api/OrphanedResults/Models/PendingDrugTest"
import { DonorNotFoundAcceptObservable } from "../../../api/OrphanedResults/ResultExceptionsProcess"
import FormatError from "../../../formatters/FormatError"
import AddIndividualModal from "../../Randomization/AddIndividualModal"
import { DraggableModalDialog } from "../../Randomization/GovPools/RandomSchedulingExclusionsModal"
import SearchBar from "../../SearchBar"
import PendingDrugTests from "../PendingDrugTests/PendingDrugTests"
import PendingDrugTestsButtons from "../PendingDrugTests/PendingDrugTestsButtons"
import { ImportExceptionSubType } from "../../../api/OrphanedResults/Models/ImportExceptionSubType"


interface DonorNotFoundErrorProps {
  errorRow: OrphanedRow
  onClose: (withUpdate: boolean) => void
}

const searchFields = [
  { Name: "All Personnel IDs" },
  { Name: "SSN" },
  { Name: "Employer ID" },
  { Name: "Driver ID" },
  { Name: "Alternate ID" },
  { Name: "First Name" },
  { Name: "Last Name" },
  { Name: "Company" },
  { Name: "Location" },
].map((el) => {
  return { Name: el.Name, ID: el.Name }
})

function DonorNotFoundError(props: DonorNotFoundErrorProps) {
  const { errorRow, onClose } = props

  const [DonorID, setDonorID] = useState(0)
  const [AddNew, setAddNew] = useState(false)
  const [Search, setSearch] = useState({ field: "", text: "" })
  const [selectedTest, setSelectedTest] = useState<PendingDrugTest>()
  const [acceptProc, setAcceptProc] = useState(false)
  const testID = errorRow.TestDetailImportID

  const onCancel = () => {
    onClose(false)
  }

  const onAccept = () => {
    setAcceptProc(true)
    const acceptOptions = {
      DonorID,
      TestDetailID: errorRow.TestDetailID,
      TestDetailClinicalID: errorRow.TestDetailClinicalID,
      PendingTestDetailID: selectedTest?.TestDetailID,
      PendingClinicalTestDetailID: selectedTest?.TestDetailClinicalID,
      TestDetailImportID: errorRow.TestDetailImportID,
      TestImportExceptionID: errorRow.TestImportExceptionID,
    }
    DonorNotFoundAcceptObservable(acceptOptions)
      .pipe(finalize(() => setAcceptProc(false)))
      .subscribe(
        (data) => {
          toast.success(data)
          onClose(true)
        },
        (error) => toast.error(FormatError(error))
      )
  }

  const onCreateNew = () => {
    setAddNew(true)
  }

  const handleSearch = (field: string, text: string) => {
    setSelectedTest(undefined)
    setSearch({ field, text })
  }

  const handleSaveDonor = (donorID?: number) => {
    setAddNew(false)
    if (donorID) setSearch({ field: "PersonID", text: donorID.toString() })
    // if (donorID) PageSubject.next({ ...PageSubject.value, search: { field: "PersonID", text: donorID.toString() } })
  }

  const dialogTitle = (row: OrphanedRow): string => {
    const donorNotFound = "Donor Not Found Error" 
    const notMatchingRandom = "No Matching Random Error"
    if(!row){
      return donorNotFound
    }
    if (!row.ImportException) {
      return donorNotFound
    }
    const importExceptionSubType = row.ImportExceptionSubTypeID
    if ((importExceptionSubType === ImportExceptionSubType.TestDoesNotExist) ||
      (importExceptionSubType === ImportExceptionSubType.MoreThanOneTestMatch)) {
      if (row.ReasonCode?.toUpperCase() === "RAN") {
        return notMatchingRandom
      }
    }
    return donorNotFound
  }
  const modalTite = dialogTitle(errorRow)
 
  return (
    <Modal dialogAs={DraggableModalDialog} backdrop="static" show size="xl" dialogClassName="dark" onHide={onClose}>
      <ModalHeader closeButton>
        <ModalTitle>{modalTite}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            Search for the Donor to assign to this result Or select Create New to create a new donor and test: .
          </Col>
        </Row>
        <Row className="my-3">
          <Col>
            <SearchBar onSearch={handleSearch} searchFields={searchFields} placeholder="All Personnel IDs" />
          </Col>
        </Row>
        <Row>
          <Col>
            <DonorGrid
              search={Search}
              donorId={DonorID}
              testID={testID}
              setDonorID={setDonorID}
              setSelectedTest={setSelectedTest}
            />
          </Col>
        </Row>
        {DonorID > 0 && !errorRow.IsClinical && (
          <Row>
            <Col>
              <PendingDrugTests
                donorId={DonorID}
                importTest={errorRow}
                selectedTest={selectedTest}
                onSelectTest={setSelectedTest}
              />
            </Col>
          </Row>
        )}
        {AddNew && <AddIndividualModal onCancel={() => setAddNew(false)} show={AddNew} onAdd={handleSaveDonor} />}
      </ModalBody>
      <Modal.Footer>
        <PendingDrugTestsButtons
          selectedTest={selectedTest}
          selectedDonor={DonorID > 0}
          disabled={acceptProc || AddNew}
          acceptSpin={acceptProc}
          createNewSpin={AddNew}
          onCancel={onCancel}
          onAccept={onAccept}
          onCreateNew={onCreateNew}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default DonorNotFoundError
